import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Início',
    icon: 'home-outline',
    link: '/pages/dashboard',
    home: true,
  },
  {
    title: 'Categorias',
    icon: 'grid-outline',
    link: '/pages/products',
  },
  /* {
    title: 'Pedidos',
    icon: 'file-text-outline',
    link: '/pages/orders',
  }, */
];
